import {Component} from '@angular/core';
import {Skeleton} from 'primeng/skeleton';

@Component({
	selector: 'app-skeleton-card-mailbox',
	standalone: true,
	host: { 'class': 'flex-1' },
	template: `
		<p-skeleton width="100%" height="6rem" />
	`,
	imports: [
		Skeleton
	],
	styles: []
})
export class SkeletonCardMailboxComponent {

}
